import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'

import { VueEditor } from 'vue2-editor'
import WhatsappMessage from '@/components/WhatsappMessage/Index'

export default {
    name: 'EditTemplate',
    computed,
    data,
    methods,
    mounted,
    components: {
        VueEditor,
        WhatsappMessage
    }
}
